module.exports = __webpack_public_path__ + "img/hn.910fe999.svg";